<template>
    <the-header-menu />
    <el-container class="reusable-page">

      <div class="lnd-cover">
        <h1 class="lnd-headline">Bezmotorový výcvik &#8211; SPL</h1>
      </div>

      <div class="main-content">
        <el-page-header content="Plachtařský výcvik" @back="goBack" title="Zpět" />
        <div class="content">
          <h3>Výcvik pilota bezmotorového kluzáku &#8211; SPL</h3>

          <span>
            Výcvik na kluzácích absolvuje většina pilotů, kteří se později začínají věnovat letectví ve své profesní kariéře. První samostatný let
            ve větroni můžete uskutečnit už po dovršení 15 let. To znamená, že s výcvikem můžete začít už ve 14 letech! Nejlepší čas pro začátek 
            výcviku je na podzim, abyste zimní měsíce mohli věnovat teoretické přípravě. A jak to probíhá?<br>
            Přes zimu u nás klasicky probíhá výuka teorie, která je rozdělena do několika tematických okruhů. Náplní jednotlivých okruhů je seznámení pilota žáka se základy letu, navigace, meteorologie, komunikace, provozních postupů a dalších. Na jaře je poté
            možné začít s prvními lety s instruktorem. Během těchto jeětě nemusíte být držitelem dále uvedených dokladů, ale před prvním samostatným letem (tzv. sólem) je nutné získat osvědčení letové
            posádky o zdravotní způsobilosti 2. třídy (tzv. medical). Toto osvědčení vydává pouze <a style="text-decoration:none" href="https://www.caa.cz/zpusobilost-leteckeho-personalu/povereni-lekari/">pověřený lékař.</a> Dále je potřeba
            být držitelem průkazu radiofonisty letecké pohyblivé služby (<a style="text-decoration:none" href="https://www.ctu.cz/druhy-prukazu">OFL nebo VFL</a>),
            který vydává Český telekomunikační úřad. <br>
            Čas, za který je možné výcvik dokončit, je velice individuální. Osnova výcviku předepisuje instruktorovi, aby žák uskutnečnil minimálně 15 letových hodin tréninkem různých technik pilotáže. Reálný nálet tak závisí především
            na Vašich dovednostech a také časových možnostech.
          </span>
          <!-- <div style="padding-top: 40px">
          <table>
            <tr>
              <th>Typ letounu</th>
              <th>Cena za l.h. výcviku</th>
            </tr>
            <tr>
              <td>L-23 Super Blaník - GLD</td>
              <td>XXXXX,- *</td>
            </tr>
          </table>
          * k ceně je nutné připočíst sazbu za vlečné letadlo<br>
            Všechny ceny jsou uvedené s DPH a sazbou instruktora<br>
          </div> -->


          <div class="vl-images-w">
            <el-carousel :interval="4000" type="card" height="200px" >
                <el-carousel-item v-for="i in photos_url" :key="i" @click="toggle()">
                    <img :src="i" loading="lazy" style="max-height:100%;">
                </el-carousel-item>
            </el-carousel>
          </div>

          <el-image-viewer v-if="viewer_toggled" :url-list="photos_url" @close='toggle()' :hide-on-click-modal='true' />

        </div>
      </div>
      <the-footer />
    </el-container>
</template>

<script>

import TheHeaderMenu from '../components/TheHeaderMenu3.vue'
import TheFooter from '../components/TheFooter.vue'

import { useRouter } from 'vue-router'
import { ref } from '@vue/reactivity'


export default {
    name: "PageGldVycvik",
    components: {
      TheHeaderMenu,
      TheFooter
    },
    setup(){
      const router = useRouter();

      const viewer_toggled = ref(false)
      const toggle = function(){
        viewer_toggled.value = !viewer_toggled.value;
      }      
      //const imgIndex = [3,7,9,10,17,33];
      let photos_url = [];

      for(let img_n of [3,7,9,10,33]){ //[3,7,9,10,17,33];
        photos_url.push(require("../../src/assets/photos/img"+String(img_n)+".jpg"))
      }


      function goBack(){
        router.back()
      }

      return {goBack, photos_url, viewer_toggled, toggle}
    }

}
</script>


<style scoped>


.vl-images-w{
    width:100%;
    padding-top: 50px;
}

.vl-images{
    
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
}
.vl-img{
    height: 200px;
    padding-top: 10px;
}


.main-content{
  width: 90%;
  padding-top: 20px;
  padding-bottom: 30px;
}
.content{
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}
.lnd-cover{
  width: 100%;
  height: 300px;
  /* background: blueviolet; */
  background-image: url("../../src/assets/cover/img17.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: 30% 200%;
  background-size: cover;
}
.lnd-headline{
  text-align: center;
  position: relative;
  top: 40%;
}
.reusable-page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  height: 100%;
  width: 100%;
  /* min-height: 100vh; */
}

</style>